import {useSelector,useDispatch} from 'react-redux'
import {
	selectAllLeaderboardRecords, 
	selectMetricCreator,
	getSquatLeaderboard
} from './slice'

export const useSquatLeaderboard = ()=>{
	const dispatch = useDispatch()
	const status = useSelector(state=>state.ai.leaderboard.status)
	const records = useSelector(selectAllLeaderboardRecords)
	if(status==='init'){
		dispatch(getSquatLeaderboard())
	}
	return {status,records}
}

export const useMetricCreator = ()=>{
	const {show,category,metrics,client,date} = useSelector(selectMetricCreator)
	const allowSave = Boolean(metrics) && Boolean(client) && Boolean(date) && Boolean(category)
	return {show,category,metrics,client,date,allowSave}
}